/*
 * @Descripttion:
 * @Author: 01387189
 * @Date: 2021-07-14 14:30:09
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-15 16:13:41
 */
// 交易合同模块
const contract = [
  {
    path: "/contract/mycontract",
    name: "mycontract",
    meta: {
      title: "合同列表-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/contract/Mycontract"),
  },
  {
    path: "/contract/contractDetail",
    name: "contractDetail",
    meta: {
      title: "合同详情-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/contract/contractDetail"),
  },
];
export default contract;
